<template>
  <Window :id="'addChildSys'" :title="title" :size="'m'" ref="Window" @Closed='close'>
    <div slot="headButton" class="fR cb tra-fast_E ml05x_E">
      <button class="bdSub boxR hover-bg-highLight" @click="hide" type="button">{{$t('cmd85',['取消'])}}</button>
      <button class="functionBtn" :class='{disable: (hasSelect&&!isok) || !plantName}' @click.stop="confirm" type="button">{{$t('cmd84',['保存'])}}</button> <!--!isok || 可以添加pv的控制-->
    </div>
    <div fillHeight="-#addChildSys .head" scroll>
      <div class="pt2x w80pct mc">
        <div class="mb05x_E">
          <div v-if="myMode=='single'">
            <div class="fs12x" :title="getLanguageStr('word197','设备名称')"><span class="cWarning">* </span>{{getLanguageStr('word197','设备名称')}}:</div>
            <InputText v-model="plantName" class="mb2x mt2x w45pct" :placeholder="$t('fill3rd125',[getLanguageStr('word197'),'请输入设备名称'])" :clearBtn="true" ref="searchBox" name="editChildSysSearch"></InputText>
          </div>
          <div v-if="type=='normal'&&selectChildSystem" class="fs12x mb1x" :title="getLanguageStr('word1785','所属系统')"><span class="cWarning">* </span>{{getLanguageStr('word1785','所属系统')}}:</div>
          <div class='posR h3x'>
            <subordinate-system v-if="type=='normal'&&selectChildSystem" class='w45pct posA' ref="subordinateSystem" :stationId="stationId" @Update="SelectSystemId"></subordinate-system>
          </div>

        </div>
        <div class="fs12x pt2x" :title="getLanguageStr('plant415','组件容量')">{{getLanguageStr('plant415','组件容量')}}(kWp):&nbsp;&nbsp;{{installedCapacity? floatFix(installedCapacity/1000,2,null,null,true) : '--(' + getLanguageStr('plant450', '组件容量将根据以下填写内容自动计算') + ')'}}</div>
        <div class='w100pct flexBox flex-r pt2x flexwrap allinput'>
          <div class='w50pct flexBox flex-r'>
            <div class='flex-1'>
              {{getLanguageStr('plant459','实际启用组串')}}
            </div>
            <div class='flex-1'>
              {{getLanguageStr('plant460','组件额定功率')}}(W)
            </div>
            <div class='flex-1'>
              {{getLanguageStr('device315','组件数量')}}
            </div>
            <div class='flex-1'>
              {{getLanguageStr('word148','合计')}}(W)
            </div>
          </div>
          <div class='w50pct flexBox flex-r pl1x'>

            <div class='flex-1'>
              {{getLanguageStr('plant459','实际启用组串')}}
            </div>
            <div class='flex-1'>
              {{getLanguageStr('plant460','组件额定功率')}}(W)
            </div>
            <div class='flex-1'>
              {{getLanguageStr('device315','组件数量')}}
            </div>
            <div class='flex-1'>
              {{getLanguageStr('word148','合计')}}(W)
            </div>
          </div>
          <div class='w50pct flexBox flex-c pt1x'>
            <div class='flexBox flex-c ' :class='{"w100pct":deviceConfigurationListAll.length%2 === 0 ? (index+1)<=(deviceConfigurationListAll.length/2) : (index+1)<=(Math.floor(deviceConfigurationListAll.length/2)+1)}' v-for="(item,index) in deviceConfigurationListAll" :key='item.useCode'>
              <div class='w100pct flexBox flex-r mt1x' v-if='deviceConfigurationListAll.length%2 === 0 ? (index+1)<=(deviceConfigurationListAll.length/2) : (index+1)<=(Math.floor(deviceConfigurationListAll.length/2)+1)'>
                <div class='flex-1 flexBox flex-a'>
                  <Checkbox class='mr1x' :text='"PV"+item.useCode' v-model="item.isSelect" @Click='changecheck'></Checkbox>
                </div>
                <div class='flex-1'>
                  <InputText class='w80pct' :placeholder="getLanguageStr('user29','请输入')" only='float2' :class='{disable: !item.isSelect}' :disabled='!item.isSelect' :ref='"ratedPower"+item.useCode' @Keyup='countAll' v-model='item.ratedPower' :verification="'~:0.01~100000000'" />
                </div>
                <div class='flex-1'>
                  <InputText class='w80pct' only='int' :placeholder="getLanguageStr('user29','请输入')" :class='{disable: !item.isSelect}' :disabled='!item.isSelect' :ref='"componentCount"+item.useCode' @Keyup='countAll' v-model="item.componentCount" :verification="'~:1~100000000'" />
                </div>
                <div class='flex-1 flexBox flex-a'>
                  {{item.componentCapacity}}
                </div>
              </div>
            </div>
          </div>
          <div class='w50pct flexBox flex-c pl1x pt1x'>
            <div class='flexBox flex-c' :class='{"w100pct":deviceConfigurationListAll.length%2 === 0 ? (index+1)>(deviceConfigurationListAll.length/2) : (index+1)>(Math.floor(deviceConfigurationListAll.length/2)+1)}' v-for="(item,index) in deviceConfigurationListAll" :key='item.useCode'>
              <div class='w100pct flexBox flex-r mt1x' v-if='deviceConfigurationListAll.length%2 === 0 ? (index+1)>(deviceConfigurationListAll.length/2) : (index+1)>(Math.floor(deviceConfigurationListAll.length/2)+1)'>
                <div class='flex-1 flexBox flex-a'>
                  <Checkbox class='mr1x' :text='"PV"+item.useCode' v-model="item.isSelect" @Click='changecheck'></Checkbox>
                </div>
                <div class='flex-1'>
                  <InputText class='w80pct' :placeholder="getLanguageStr('user29','请输入')" only='float2' :class='{disable: !item.isSelect}' :ref='"ratedPower"+item.useCode' :disabled='!item.isSelect' @Keyup='countAll' v-model="item.ratedPower" :verification="'~:0.01~100000000'" />
                </div>
                <div class='flex-1'>
                  <InputText class='w80pct' :placeholder="getLanguageStr('user29','请输入')" only='int' :class='{disable: !item.isSelect}' :disabled='!item.isSelect' :ref='"componentCount"+item.useCode' @Keyup='countAll' v-model="item.componentCount" :verification="'~:1~100000000'" />
                </div>
                <div class='flex-1 flexBox flex-a'>
                  {{item.componentCapacity}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <button slot="btmBtn" class="functionBtn" type="button" @click="confirm" >{{getLanguageStr('cmd84','保存')}}</button> -->
  </Window>
</template>
<script>
import Window from '@/components/common/ui/WindowForNew.vue'
import InputText from '@/components/common/ui/InputText.vue'
import SubordinateSystem from '@/view/maintain/part/childSys/SubordinateSystem.vue'
import Checkbox from '@/components/common/ui/Checkbox.vue'
import { getLanguageStr } from '@/util/language'
import * as lib from '@/util/lib.js'
import * as historyApi from '@/api/maintain/plant/list'

export default {
  name: 'EditChildSysDevice',
  components: { Window, InputText, SubordinateSystem, Checkbox },
  props: {
    type: { type: String, default: 'normal' }, // "normal","onlyName",部分设备若要改名，必须传systemId
    selectChildSystem: { type: Boolean, default: true }// 是否可选择子系统
  },
  data () {
    return {
      myMode: 'single',
      stationId: '',
      systemId: '',
      productId: '',
      title: '',
      plantName: '',
      deviceId: '',
      selectStationId: '',
      selectIds: [],
      deviceConfigurationListAll: [],
      installedCapacity: 0,
      isok: false,
      instance: null,
      hasSelect: false
    }
  },
  watch: {
    deviceConfigurationListAll: {
      deep: true,
      handler: function (data) {
        let arr = data.filter(item => {
          if (item.isSelect) return item
        })
        if (arr && arr.length) this.hasSelect = true
        else {
          this.hasSelect = false
        }
      }
    }
  },
  methods: {
    getLanguageStr,
    floatFix: lib.floatFix,
    close () {
      this.instance.destroyUi()
    },
    show (data, instance) {
      this.instance = instance
      this.productId = data.productId
      this.plantName = data.plantName
      if (data.hasOwnProperty('selectIds')) {
        this.selectIds = data.selectIds
        this.systemId = data.stationId
      } else {
        this.systemId = data.systemId
        this.deviceId = data.deviceId
      }
      this.stationId = data.stationId
      if (this.myMode == 'single') {
        this.title = getLanguageStr('plant464', '编辑设备信息')
      } else {
        this.title = getLanguageStr('plant1', '批量选择所属系统')
      }
      this.$refs.Window.show({
        title: this.title
      })
      if (this.type == 'normal' && this.selectChildSystem) this.$refs.subordinateSystem.init(this.stationId, this.systemId)
      this.getconfig()
      lib.fillHeight()
      setTimeout(() => {
        lib.setScroll($(this.$el).find('[scroll]'))
      }, 500)
      
    },
    countAll () {
      this.$nextTick(() => {
        let isok = true
        let isSelect = false
        this.installedCapacity = 0
        this.deviceConfigurationListAll = this.deviceConfigurationListAll.map(item => {
          if (item.isSelect) {
            isSelect = true
            if (item.ratedPower && item.componentCount && !isNaN(item.ratedPower) && !isNaN(item.componentCount) && ((item.ratedPower < 0.01 || item.ratedPower > 100000000) || (item.componentCount < 1 || item.componentCount > 100000000))) {
              isok = false
              item.componentCapacity = '--'
            } else if (!item.ratedPower || !item.componentCount) {
              isok = false
              item.componentCapacity = '--'
            } else {
              item.componentCapacity = Number(item.ratedPower) * Number(item.componentCount)
            }
            this.installedCapacity += (!isNaN(item.componentCapacity) ? item.componentCapacity : 0)
            if (this.installedCapacity !== null) {
              this.installedCapacity = this.installedCapacity
            }
          } else {
            item.ratedPower = null
            item.componentCount = null
            item.componentCapacity = '--'
            this.$refs['ratedPower' + item.useCode][0].reset()
            this.$refs['componentCount' + item.useCode][0].reset()
          }
          return item
        })
        this.isok = isSelect ? isok : false
      })
    },
    getconfig () {
      historyApi.deviceConfig(this.stationId, { deviceId: this.deviceId, productId: this.productId }).then(data => {
        this.deviceConfigurationListAll = []
        data.codeList = data.codeList || []
        data.codeList = data.codeList.map(item => {
          return Number(item)
        })
        data.codeList.map(item => {
          this.deviceConfigurationListAll.push({
            useCode: item,
            ratedPower: '',
            componentCount: '',
            componentCapacity: '--',
            isSelect: false
          })
        })
        data.deviceConfigurationList = data.deviceConfigurationList || []
        data.deviceConfigurationList.map(item => {
          let index = data.codeList.indexOf(Number(item.useCode))
          // console.log(index, data.codeList, item.useCode)
          if (index !== -1) {
            this.deviceConfigurationListAll[index] = { ...item, isSelect: true, componentCapacity: Number(item.ratedPower) * Number(item.componentCount) }
          }
        })
        this.countAll()
      })
    },
    changecheck (a) {
      this.$nextTick(() => {
        this.countAll()
      })
    },
    modeChange (mode) {
      this.myMode = mode
    },
    hide () {
      this.$refs.Window.hide()
    },
    SelectSystemId (id) {
      this.selectStationId = id
    },
    confirm () {
      this.$refs.Window.hide()
      let req
      req = {
        name: this.plantName,
        installedCapacity: this.floatFix(this.installedCapacity / 1000, 2, null, null, true),
        systemId: this.selectStationId || this.systemId || undefined
      }
      req.deviceConfigurationList = this.deviceConfigurationListAll.filter(item => {
        if (item.isSelect) return item
      })
      if (!req.deviceConfigurationList || req.deviceConfigurationList.length === 0) {
        req.installedCapacity = null
      }
      historyApi.apiReplaceDevice(this.stationId, this.deviceId, req).then(res => {
        this.$emit('editSuccess')
      }, error => {
        !_.isEmpty(error) && this.$notify(error)
      })
    }
  }
}
</script>
<style scoped>
.flexBox {
  display: flex;
}
.flex-r {
  flex-direction: row;
}
.flex-1 {
  flex: 1;
}
.flex-2 {
  flex: 2;
}
.flexwrap {
  flex-wrap: wrap;
}
.flex-c {
  flex-direction: column;
}
.flex-a {
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/part/childSys/EditChildSysDeviceInv.vue